module.exports = __webpack_public_path__ + "img/image-regular-full.98369d80.svg";